// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMemo } from 'react';
import { generateUniqueId, useUniqueId } from '../../../hooks/use-unique-id';
export var useIds = function (_a) {
    var hasSelectedOption = _a.hasSelectedOption;
    return {
        selectedOptionId: useMemo(function () { return (hasSelectedOption ? generateUniqueId() : undefined); }, [hasSelectedOption]),
        menuId: useUniqueId('option-list')
    };
};
export var getOptionId = function (menuId, index) {
    if (index < 0) {
        return undefined;
    }
    return "".concat(menuId, "-option-").concat(index);
};
//# sourceMappingURL=use-ids.js.map